import { ReactNode } from 'react';

export type TagTone = 'success' | 'warn' | 'danger' | 'accent' | 'neutral';

interface StatusTagProps {
  tone?: TagTone;
  dot?: boolean;
  children: ReactNode;
}

const toneClasses: Record<TagTone, string> = {
  success: 'bg-success-soft text-success',
  warn: 'bg-warn-soft text-warn',
  danger: 'bg-danger-soft text-danger',
  accent: 'bg-accent-soft text-accent',
  neutral: 'bg-bg-elevated text-text-2',
};

export function StatusTag({ tone = 'neutral', dot = true, children }: StatusTagProps) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-[7px] py-px rounded-lg text-[10.5px] font-semibold ${toneClasses[tone]}`}
    >
      {dot && <span className="w-[5px] h-[5px] rounded-full bg-current" />}
      {children}
    </span>
  );
}
